import React from 'react';
import { makeStyles } from '@mui/styles';
import { useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Container,
  useScrollTrigger,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import { useClamp } from '@utils/useClamp';
import { TabletNavbar } from './TabletNavbar';
import { DesktopNavbar } from './DesktopNavbar';
import BannerRenovacion from '@components/banner/BannerRenovacion';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
  logo: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'space-around',
  },
  spacer: {
    marginLeft: theme.spacing(2),
  },
  menu: {
    padding: 0,
  },
  popOverPaper: {
    width: '100%',
    marginTop: 40,
  },
}));

export const Navbar: React.FC = () => {
  const {clamp} = useClamp();
  const classes = useStyles();
  const { pathname } = useLocation();
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  const trigger = useScrollTrigger({
    threshold: 80,
    disableHysteresis: true,
  });

  const isCurrentHome = (): boolean => {
    if (pathname === '/') {
      return false;
    } else if (pathname === '/home-alt') {
      return false;
    } else if (pathname === '/quotation') {
      return false;
    }
    return true;
  };

  return (
    <div className={classes.root}>
      <AppBar
        elevation={trigger || isCurrentHome() ? 4 : 0}
        position={'fixed'}
        style={{ background: '#fafafa' }}
      >
        <BannerRenovacion/>
        <Container>
          <Toolbar
            style={{
              paddingLeft: 0,
              paddingRight: 0,
              width: '100%',
            }}
          >
            { clamp(<DesktopNavbar />, <TabletNavbar />) }
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
};
